const isNonEmptyId = (value) =>
  typeof value === "string" && value.trim().length > 0;

export const hasKnownElementIdentity = (element) =>
  isNonEmptyId(element?.id) && isNonEmptyId(element?.dataObjectID);

export const isElementClone = (element) =>
  hasKnownElementIdentity(element) && element.id !== element.dataObjectID;

export const canUploadReplacementModel = (elementId, elementData) =>
  isNonEmptyId(elementId) &&
  elementData?.id === elementId &&
  hasKnownElementIdentity(elementData) &&
  elementData.id === elementData.dataObjectID;
